import DashboardBody from "./DashboardBody";
import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";

const DashboardPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--dashboard">
        <SideBar />
        <DashboardBody />
      </div>
    </main>
  );
};

export default DashboardPage;
